export default __webpack_public_path__ + "static/media/distance.f67966a0.svg";